import type { Language } from '@offer-catalog/services/i18n'

export const sharedQueryKeys = {
  countries: (currentLanguage: Language) => ['countries', currentLanguage] as const,
  parameters: (uid: string | undefined) => ['useParameters', uid] as const,
  seasons: () => ['useSeasons'] as const,
  czListSets: () => ['cz-list-sets'] as const,
}
